module.exports = __webpack_public_path__ + "static/media/teaser2x.b92117b2.gif";